import { wpApiInstance} from '../api/wp-api';
import { apiRetry } from '../api/api-helper';

import { IPortalUserResponse } from '../models/user.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * @description Function to get a list of portal users
 * 
 * @returns {IPortalUserResponse} the api response | error
 */
const GetUsers = async (): Promise<IPortalUserResponse> => {
  try {
    apiRetry(wpApiInstance);

    const { data } = await wpApiInstance.get('/admin/users');

    return data;
  } catch (error) {
    handleRouteError(error, 'Error getting portal user data');
    throw(error);
  }
}
 
export default GetUsers;